export const BUDDY_FAQ_QUESTIONS = [
  {
    sectionTitle: 'Frequently Asked Questions',
    content: [
      {
        q: 'Do I get a discount if I buy more than one Buddy?',
        a: 'Each additional Buddy will be $119. Discount will automatically reflect in cart.',
      },
      {
        q: 'Do I need one Buddy per child?',
        a: 'Buddy is designed for one child per device. We designed Buddy to feel personal — Routines, Rewards, streaks, wake-up settings, and preferences are all tied to one child. This helps create a strong sense of ownership and independence.',
      },
      {
        q: 'What age is Buddy designed for?',
        a: 'Buddy works best for children building independence — typically ages 4–10. Older kids may still benefit, especially if they like tracking goals, streaks, and rewards.',
      },
      {
        q: 'Does Buddy require a subscription?',
        a: "Buddy works out of the box with core features included. A subscription unlocks additional premium experiences designed to deepen engagement — such as rewards, timers, reminders, and other exciting features coming soon.\nWe'll always clearly outline which features are included and which require a subscription before you purchase.\nIf you are already a Calendar Plus subscriber, Buddy Plus is included for free and there is no need for you to start an additional subscription.",
      },
      {
        q: 'How durable is Buddy?',
        a: 'Buddy was designed with kids in mind. It features a sturdy build that helps it handle everyday bumps, knocks, and enthusiastic use. For added protection, you can buy a colorful silicone case — they fit snugly around Buddy and protect it from typical wear.',
      },
      {
        q: 'Can Buddy be wall mounted?',
        a: 'Buddy cannot be wall mounted. It is designed to sit on a surface like a nightstand or a desk.',
      },
      {
        q: 'Do I need to have a Skylight Calendar to use Buddy?',
        a: "You do not need a Skylight Calendar to use Buddy.\nIf you already own a Calendar, Buddy can complement it by giving your child a dedicated device in their room while Calendar remains the central family hub.\nIf you don't own a Calendar, Buddy still fully supports routines, chores, wake-up, and other core features on its own.",
      },
      {
        q: 'What is the difference between Skylight Buddy and Skylight Calendar?',
        a: 'Skylight Buddy was specifically designed with kids in mind to help them navigate their daily chores and routines. Skylight Calendar helps lighten parents’ mental load by aggregating the whole families’ schedules, and helps organize the week with additional features like color-coded lists, synced calendar apps, meal plans, and more.',
      },
      {
        q: 'If I sync Buddy to my Skylight Calendar, will events appear on Buddy?',
        a: `Buddy syncs tasks and routines from the Skylight app. Calendar events won't appear on the device. For the full family schedule, your Skylight Calendar is the place to go.`,
      },
      {
        q: 'Does Buddy have a camera or microphone?',
        a: 'No!',
      },
      {
        q: "Is Buddy safe for kids' bedrooms?",
        a: "Yes. It features a sturdy build that helps it handle everyday bumps, knocks, and enthusiastic use, and Skylight also protects your family's information with strict data privacy guidelines.",
      },
      {
        q: 'Can the screen turn off at night?',
        a: "Yes! Buddy's screen can either turn off at night or transition to a clock screensaver.",
      },
      {
        q: 'Can my child access the internet or other apps via Buddy?',
        a: 'No! Buddy is a purpose-built routine device, not a general tablet. Buddy does not include internet browsing, YouTube, social media, or the ability to download any apps.',
      },
    ],
  },
]
